export default __webpack_public_path__ + "static/illustration-desc.url-c3da8d7e2a4298fbac913fbe1b40e615.svg";